import { computed, ref } from 'vue'
import { AllowedIcons } from '../../../types/icons'
import type { TExpandableTextProps } from './types'

/**
 * Controller for TExpandableText component
 * @param props - Component props
 */
export function setup(props: TExpandableTextProps) {
  const expanded = ref(false)

  /**
   * Whether the text exceeds maxLength and needs truncation
   */
  const needsTruncation = computed(() => {
    return props.text.length > props.maxLength
  })

  /**
   * The text to display - truncated or full based on expanded state
   */
  const displayText = computed(() => {
    if (!needsTruncation.value || expanded.value) {
      return props.text
    }
    return props.text.slice(0, props.maxLength) + '...'
  })

  /**
   * The current toggle button label based on expanded state
   */
  const toggleLabel = computed(() => {
    return expanded.value ? props.collapseLabel : props.expandLabel
  })

  /**
   * The current icon based on expanded state
   */
  const toggleIcon = computed(() => {
    return expanded.value ? AllowedIcons.chevronUp : AllowedIcons.chevronDown
  })

  /**
   * Toggle the expanded state
   */
  function toggle() {
    expanded.value = !expanded.value
  }

  return {
    expanded,
    needsTruncation,
    displayText,
    toggleLabel,
    toggleIcon,
    toggle,
  }
}
